"use client";

import React, { useState, useRef } from "react";
import * as S from "./styles";
import { X } from "lucide-react";

type UploadImageProps = {
  multiple?: boolean;
};

const UploadImage: React.FC<UploadImageProps> = ({ multiple = false }) => {
  const [images, setImages] = useState<string[]>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const fileArray = Array.from(files);
    const newImages = fileArray.map((file) => URL.createObjectURL(file));

    setImages((prev) => (multiple ? [...prev, ...newImages] : newImages));
  };

  const handleRemove = (index: number) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <S.Container>
      {multiple ? (
        <>
          <S.UploadButton onClick={handleClick}>
            <span>+ Upload</span>
          </S.UploadButton>

          <S.ImageList>
            {images.map((img, index) => (
              <S.ImagePreview key={index}>
                <img src={img} alt={`Preview ${index}`} />
                <S.Close onClick={() => handleRemove(index)}>
                  <X size={16} />
                </S.Close>
              </S.ImagePreview>
            ))}
          </S.ImageList>
        </>
      ) : (
        <S.UploadButton onClick={handleClick}>
          {images.length === 0 ? (
            <span>+ Upload</span>
          ) : (
            <>
              <img src={images[0]} alt="Preview única" />
              <S.Close onClick={() => handleRemove(0)}>
                <X size={16} />
              </S.Close>
            </>
          )}
        </S.UploadButton>
      )}

      <input
        type="file"
        accept="image/*"
        multiple={multiple}
        onChange={handleUpload}
        style={{ display: "none" }}
        ref={inputRef}
      />
    </S.Container>
  );
};

export default UploadImage;
